const KeenSlider = window.KeenSlider

const { setInitialised, useDots } = window.BAO.Carousel.plugins

class BridalCarousel extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    if (!this.els?.slide?.exists) return

    this.carousel = this.setupCarousel()
  }

  setupCarousel () {
    return new KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        loop: false,
        mode: 'snap',
        slides: {
          perView: 1,
        },
        breakpoints: {
          '(min-width: 901px)': {
            disabled: true,
          },
        },
      },
      [setInitialised(), useDots(this.els?.dot?.elements)],
    )
  }
}

if (!customElements.get('bridal-carousel')) {
  customElements.define('bridal-carousel', BridalCarousel)
}
